<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="txt-head black--text d-flex justify-space-between">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 4 :</span> ผลผลิต /
          ตัวชี้วัดความสำเร็จ
        </div>

        <v-btn
          icon
          :class="{ rotate180: OOIExpanded }"
          @click="OOIExpanded = !OOIExpanded"
        >
          <Iconify
            icon="material-symbols:keyboard-arrow-down"
            color="var(--theme-color-seven)"
          ></Iconify>
        </v-btn>
      </div>

      <div
        class="card-part expandable pt-0"
        :class="{ 'expanded mt-3': OOIExpanded }"
      >
        <div class="txt-head black--text mb-3">
          1. ตัวชี้วัดความสำเร็จ
          <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
        </div>

        <div class="d-flex black--text font-type-bold mb-5 gap-24">
          <div style="width: 50%"></div>
          <div style="width: 25%; text-indent: 30%">RSP</div>
          <div style="width: 25%; text-indent: 30%">สป.อว.</div>
        </div>

        <div class="d-flex flex-column gap-16">
          <div v-for="(plan, pi) in masterData.plan_master" :key="pi">
            <div class="black--text font-type-bold mb-5 d-flex align-center">
              {{ plan.plan_name_th }}
              <Button
                v-if="
                  isOIC &&
                  form.kpi_annex_plans.find(
                    (x) => x.plan?.plan_master?.id == plan.id
                  )
                "
                theme="8"
                class="ml-3"
                height="32px"
                :disabled="rejectedPlans.includes(plan.id)"
                @onClick="rejectPlan(plan)"
                >Reject</Button
              >
            </div>

            <div
              v-for="(item, i) in plan.kpi_masters"
              :key="i"
              class="d-flex flex-column gap-8"
            >
              <div
                v-if="item.prefix_flag"
                class="font-type-bold black--text mb-3 pl-10"
              >
                {{ item.name }}
              </div>

              <div v-else class="d-flex gap-24">
                <!--   ผลผลิต   -->
                <div
                  class="mb-3 black--text d-flex gap-12 pt-2 pl-10"
                  style="width: 50%"
                >
                  <div
                    class="font-type-bold flex"
                    style="min-width: 80px; max-width: 80px"
                  >
                    ตัวชี้วัดที่ {{ item.no }}
                  </div>
                  <div class="flex">{{ item.name }}</div>
                </div>

                <div class="d-flex gap-12" style="width: 25%">
                  <TextField
                    theme="3"
                    input-type="decimal"
                    :readonly="isOIC || isRSP"
                    isFormat
                    :value="kpi[item.id] ? kpi[item.id].kpi_value : ''"
                  ></TextField>
                  <div class="pt-2" style="min-width: 130px">
                    {{ item.unit }}
                  </div>
                </div>

                <div class="d-flex gap-12" style="width: 25%">
                  <TextField
                      v-if="item.no !== '22'"
                    theme="3"
                    input-type="decimal"
                    isFormat
                    :readonly="isRSP || rejectedPlans.includes(plan.id)"
                    :value="kpi[item.id] ? kpi[item.id].kpi_value_ops : ''"
                    @onChange="setKpiField(item.id, $event)"
                  ></TextField>
                  <div class="pt-2" style="min-width: 130px">
                    {{ item.unit }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <!--  OIC Comment  -->
    <divcard v-if="isOIC">
      <div class="d-flex justify-space-between txt-head black--text">
        <div>ความคิดเห็น/ข้อเสนอแนะ</div>

        <v-btn
          icon
          :class="{ rotate180: expandedComment }"
          @click="expandedComment = !expandedComment"
        >
          <Iconify
            icon="material-symbols:keyboard-arrow-down"
            color="var(--theme-color-seven)"
          ></Iconify>
        </v-btn>
      </div>

      <div
        class="card-part pt-0 expandable"
        :class="{ 'expanded mt-5': expandedComment }"
      >
        <div>
          <div class="card-part">
            <div class="mb-3 black--text">
              <span class="black--text">
                1. แผนงานพัฒนาบริการอุทยานวิทยาศาสตร์ (Service Platform)
              </span>
            </div>
            <TextArea
              theme="3"
              :value="form.plan_serv_plat_desc"
              @onChange="setFormField('plan_serv_plat_desc', $event)"
            ></TextArea>
          </div>

          <div class="card-part">
            <div class="mb-3 black--text">
              <span class="black--text">
                2. แผนงานบ่มเพาะธุรกิจวิทยาศาสตร์ เทคโนโลยีและนวัตกรรม (STI
                Business Incubation)
              </span>
            </div>
            <TextArea
              theme="3"
              :value="form.plan_sti_desc"
              @onChange="setFormField('plan_sti_desc', $event)"
            ></TextArea>
          </div>

          <div class="card-part">
            <div class="mb-3 black--text">
              <span class="black--text">
                3.
                แผนงานพัฒนาขีดความสามารถทางเทคโนโลยีและวิจัยของภาคเอกชนในพื้นที่
                (IRTC)
              </span>
            </div>
            <TextArea
              theme="3"
              :value="form.plan_irtc_desc"
              @onChange="setFormField('plan_irtc_desc', $event)"
            ></TextArea>
          </div>

          <div class="card-part">
            <div class="mb-3 black--text">
              <span class="black--text">
                4. แผนงานวิจัยร่วมกับภาคเอกชน (Collaborative Research)
              </span>
            </div>
            <TextArea
              theme="3"
              :value="form.plan_collab_desc"
              @onChange="setFormField('plan_collab_desc', $event)"
            ></TextArea>
          </div>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-5">
            2. ผลลัพธ์และผลกระทบ
            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
          </div>

          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงปริมาณ</div>
              <Wysiwyg
                theme="3"
                :readonly="isOIC"
                height="220"
                :value="form.kpi_quantity"
                @onChange="setFormField('kpi_quantity', $event)"
              ></Wysiwyg>
            </div>

            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงคุณภาพ</div>
              <Wysiwyg
                theme="3"
                :readonly="isOIC"
                height="220"
                :value="form.kpi_quality"
                @onChange="setFormField('kpi_quality', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="txt-head black--text d-flex justify-space-between">
        <div>
          3. ภาคผนวก (แผนงาน)
          <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
        </div>

        <v-btn
          icon
          :class="{ rotate180: expanded }"
          @click="expanded = !expanded"
        >
          <Iconify
            icon="material-symbols:keyboard-arrow-down"
            color="var(--theme-color-seven)"
          ></Iconify>
        </v-btn>
      </div>

      <div
        class="card-part pt-0 expandable"
        :class="{ 'expanded mt-5': expanded }"
      >
        <div v-if="!isOIC">
          <div class="mb-3">
            <div class="font-type-bold mb-1">แผนงานที่ 1</div>
            <AutoBox
              theme="3"
              :items="plansWithoutDuplicate(annexProjects[0].plan_id)"
              :item-text="itemText"
              item-value="id"
              :value="annexProjects[0].plan_id"
              @onChange="
                annexProjects[0].plan_id = $event;
                $forceUpdate();
              "
            ></AutoBox>
          </div>

          <div class="d-flex align-center gap-16 mb-3">
            <div>
              <div class="font-type-bold mb-1">
                เอกสารแนบเพิ่มเติมแผนงานที่ 1
              </div>
              <v-text-field
                v-if="
                  form.kpi_annex_plans[0].attachment &&
                  checkValType(form.kpi_annex_plans[0].attachment.file_name) ===
                    'string'
                "
                :value="form.kpi_annex_plans[0].attachment.file_name"
                id="kpi_annex_plans_0"
                outlined
                color="#F15A29"
                style="border-radius: 30px; width: 400px"
                readonly
                clearable
                @click:clear="clearKpiAnnexPlan(0)"
              ></v-text-field>
              <v-file-input
                v-else
                prepend-icon
                solo
                flat
                :rules="rulesFile"
                class="custom-textfield-theme-3"
                style="width: 400px"
                accept="application/pdf,.doc,.docx"
                @change="annexFile($event, 0)"
              ></v-file-input>
            </div>

            <Button theme="3" @click="selectFile(0)">อัพโหลด </Button>
          </div>

          <div class="mb-3">
            <div class="font-type-bold mb-1">แผนงานที่ 2</div>
            <AutoBox
              theme="3"
              :items="plansWithoutDuplicate(annexProjects[1].plan_id)"
              :item-text="itemText"
              item-value="id"
              :value="annexProjects[1].plan_id"
              @onChange="
                annexProjects[1].plan_id = $event;
                $forceUpdate();
              "
            ></AutoBox>
          </div>

          <div class="d-flex align-center gap-16 mb-3">
            <div>
              <div class="font-type-bold mb-1">
                เอกสารแนบเพิ่มเติมแผนงานที่ 2
              </div>
              <v-text-field
                v-if="
                  form.kpi_annex_plans[1].attachment &&
                  checkValType(form.kpi_annex_plans[1].attachment.file_name) ===
                    'string'
                "
                :value="form.kpi_annex_plans[1].attachment.file_name"
                id="kpi_annex_plans_1"
                outlined
                color="#F15A29"
                style="border-radius: 30px; width: 400px"
                readonly
                clearable
                @click:clear="clearKpiAnnexPlan(1)"
              ></v-text-field>
              <v-file-input
                v-else
                prepend-icon
                solo
                flat
                :rules="rulesFile"
                class="custom-textfield-theme-3"
                style="width: 400px"
                accept="application/pdf,.doc,.docx"
                @change="annexFile($event, 1)"
              ></v-file-input>
            </div>

            <Button theme="3" @click="selectFile(1)">อัพโหลด </Button>
          </div>

          <div class="mb-3">
            <div class="font-type-bold mb-1">แผนงานที่ 3</div>
            <AutoBox
              theme="3"
              :items="plansWithoutDuplicate(annexProjects[2].plan_id)"
              :item-text="itemText"
              item-value="id"
              :value="annexProjects[2].plan_id"
              @onChange="
                annexProjects[2].plan_id = $event;
                $forceUpdate();
              "
            ></AutoBox>
          </div>

          <div class="d-flex align-center gap-16 mb-3">
            <div>
              <div class="font-type-bold mb-1">
                เอกสารแนบเพิ่มเติมแผนงานที่ 3
              </div>
              <v-text-field
                v-if="
                  form.kpi_annex_plans[2].attachment &&
                  checkValType(form.kpi_annex_plans[2].attachment.file_name) ===
                    'string'
                "
                :value="form.kpi_annex_plans[2].attachment.file_name"
                id="kpi_annex_plans_2"
                outlined
                color="#F15A29"
                style="border-radius: 30px; width: 400px"
                readonly
                clearable
                @click:clear="clearKpiAnnexPlan(2)"
              ></v-text-field>
              <v-file-input
                v-else
                prepend-icon
                solo
                flat
                :rules="rulesFile"
                class="custom-textfield-theme-3"
                style="width: 400px"
                accept="application/pdf,.doc,.docx"
                @change="annexFile($event, 2)"
              ></v-file-input>
            </div>

            <Button theme="3" @click="selectFile(2)">อัพโหลด </Button>
          </div>

          <div class="mb-3">
            <div class="font-type-bold mb-1">แผนงานที่ 4</div>
            <AutoBox
              theme="3"
              :items="plansWithoutDuplicate(annexProjects[3].plan_id)"
              :item-text="itemText"
              item-value="id"
              :value="annexProjects[3].plan_id"
              @onChange="
                annexProjects[3].plan_id = $event;
                $forceUpdate();
              "
            ></AutoBox>
          </div>

          <div class="d-flex align-center gap-16">
            <div>
              <div class="font-type-bold mb-1">
                เอกสารแนบเพิ่มเติมแผนงานที่ 4
              </div>
              <v-text-field
                v-if="
                  form.kpi_annex_plans[3].attachment &&
                  checkValType(form.kpi_annex_plans[3].attachment.file_name) ===
                    'string'
                "
                :value="form.kpi_annex_plans[3].attachment.file_name"
                id="kpi_annex_plans_3"
                outlined
                color="#F15A29"
                style="border-radius: 30px; width: 400px"
                readonly
                clearable
                @click:clear="clearKpiAnnexPlan(3)"
              ></v-text-field>
              <v-file-input
                v-else
                prepend-icon
                solo
                flat
                :rules="rulesFile"
                class="custom-textfield-theme-3"
                style="width: 400px"
                accept="application/pdf,.doc,.docx"
                @change="annexFile($event, 3)"
              ></v-file-input>
            </div>

            <Button theme="3" @click="selectFile(3)">อัพโหลด </Button>
          </div>
        </div>

        <div v-else>
          <div
            class="d-flex flex-column gap-24"
            v-for="(item, i) in form.kpi_annex_plans"
            :key="i"
          >
            <div class="d-flex mt-2" style="gap: 48px">
              <div class="font-type-bold">
                <div class="mb-2">แผนงานที่ {{ i + 1 }}</div>
                <v-btn
                    v-if="item.attachment != null"
                    depressed
                    dark
                    rounded
                    width="125"
                    color="#F15A29"
                    class="to-hide"
                    @click="downloadFile(item.attachment)"
                >
                  <Iconify
                      style="color: #fff"
                      icon="system-uicons:download"
                  ></Iconify>
                  <span class="font-12 font-w-700">ดาวน์โหลด</span>
                </v-btn>
              </div>
              <div>
                <div class="mb-3">
                  {{ item.plan?.plan_master?.plan_name_th }}
                </div>
                <div>
                  {{ item.attachment?.file_name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField";
import TextArea from "../../../components/input/TextArea";
import SwitchInset from "../../../components/input/SwitchInset";
import OOILineField from "../../../components/OOILineField";
import Button from "../../../components/input/Button";
import AutoBox from "../../../components/input/AutoBox";
import { eventBus } from "../../../plugins/global-funcs";
import { mapState } from "vuex";
import { apiDomain } from "@/store/constants";
import axios from "axios";
import Wysiwyg from "../../../components/input/Wysiwyg.vue";

export default {
  name: "AFormOOI",
  components: {
    TextField,
    TextArea,
    SwitchInset,
    AutoBox,
    OOILineField,
    Button,
    Wysiwyg,
  },
  props: {
    masterData: {
      default: () => ({}),
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      form: {},
      OOIExpanded: true,
      expanded: true,
      expandedComment: true,
      rejectedPlans: [],
      kpi: {},
      annexProjects: [{}, {}, {}, {}],
      rulesFile: [
        (value) =>
          !value ||
          value.size < 50000000 ||
          "File size should be less than 50 MB!",
        (value) => !!value || "กรุณาแนบเอกสาร",
      ],
    };
  },
  computed: {
    ...mapState({
      OOIForm: (state) => state.AForm.OOIForm,
      isOIC: (state) => state.Auth.User.user_type === "สป.อว.",
      isRSP: (state) => state.Auth.User.user_type === "RSP",
    }),
  },
  created() {
    if (this.isSameId && !this.masterData.form_a) this.form = this.OOIForm;
    if (this.masterData.form_a) {
      this.setData();
    }
    eventBus.$on("aFormOOI", () => {
      eventBus.$emit("aFormOOISend", {
        ...this.form,
        kpi_values: Object.values(this.kpi),
        kpi_annex_plans: this.annexProjects,
      });
    });

    eventBus.$on("aFormOOISetData", () => this.setData());
  },
  methods: {
    setFormField(field, val) {
      this.form[field] = val;
      this.$forceUpdate();
    },
    plansWithoutDuplicate(current = undefined) {
      let selected = [
        this.annexProjects[0].plan_id,
        this.annexProjects[1].plan_id,
        this.annexProjects[2].plan_id,
        this.annexProjects[3].plan_id,
      ];
      if (current) {
        return this.masterData.plans.filter(
          (x) => x.id == current || !selected.includes(x.id)
        );
      }
      return this.masterData.plans.filter((x) => !selected.includes(x.id));
    },
    setData() {
      this.form = {
        kpi_quantity: this.masterData.form_a.form_ab_general_info?.kpi_quantity,
        kpi_quality: this.masterData.form_a.form_ab_general_info?.kpi_quality,
        plan_serv_plat_desc:
          this.masterData.form_a.form_ab_general_info?.plan_serv_plat_desc,
        plan_sti_desc:
          this.masterData.form_a.form_ab_general_info?.plan_sti_desc,
        plan_irtc_desc:
          this.masterData.form_a.form_ab_general_info?.plan_irtc_desc,
        plan_collab_desc:
          this.masterData.form_a.form_ab_general_info?.plan_collab_desc,
      };
      console.log("this.form setData()", this.form);
      if (
        this.masterData.form_a.kpi_annex_plans &&
        this.masterData.form_a.kpi_annex_plans.length == 4
      ) {
        this.annexProjects = this.masterData.form_a.kpi_annex_plans;
      } else {
        let a = this.masterData.form_a.kpi_annex_plans;
        let diff = 4 - a.length;
        while (diff > 0) {
          a.push({});
          diff--;
        }
        this.annexProjects = a;
      }

      if (this.isOIC) {
        // rejected plans
        this.rejectedPlans = this.annexProjects
          .filter((x) => x.is_reject)
          .map((x) => x.plan.plan_master.id);
      }
      this.form.kpi_annex_plans = this.annexProjects;
      // console.log('this.form.kpi_annex_plans', this.form.kpi_annex_plans) // has data verified
      if (this.form.kpi_annex_plans) {
        this.form.kpi_annex_plans.forEach((item, index) => {
          // console.log('item', item) // has data verified
          if (item.attachment && item.attachment.length > 0) {
            this.form.kpi_annex_plans[index].attachment = item.attachment[0];
            console.log(
              "this.form.kpi_annex_plans[index].attachment",
              this.form.kpi_annex_plans[index].attachment
            );
          }
        });
      }

      for (const x of this.masterData.plan_master) {
        for (const y of x.kpi_masters) {
          if (y.kpi_values) {
            this.kpi[y.id] = {};
            this.kpi[y.id].kpi_master_id = y.id;
            this.kpi[y.id].id = y.kpi_values.id;
            this.kpi[y.id].kpi_value = y.kpi_values.kpi_value;
            this.kpi[y.id].kpi_value_ops = y.kpi_values.kpi_value_ops;
          }
        }
      }
    },
    setKpiField(id, val) {
      // format {
      //   kpi_master_id: '',
      //   kpi_value: ''
      // }
      if (!this.kpi[id]) this.kpi[id] = {};
      this.kpi[id].kpi_master_id = id;
      this.kpi[id].kpi_value_ops = val;
      this.$forceUpdate();
    },
    itemText(val) {
      return val.plan_master.plan_name_th;
    },
    annexFile(val, index) {
      this.form.kpi_annex_plans[index].attachment = val;
      console.log("annex file selected", this.form.kpi_annex_plans[index]);
      this.$forceUpdate();
    },
    checkValType(val) {
      return typeof val;
    },
    clearKpiAnnexPlan(index) {
      this.form.kpi_annex_plans[index].attachment = null;
      this.$forceUpdate();
    },
    selectFile(id) {
      // querySelector id file จากนั้นเรียก event click
      document.querySelector("#kpi_annex_plans_" + id).click();
    },
    downloadFile(file) {
      axios({
        url: `/api/download/${file.id}`,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file.file_name);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          this.$store.commit("General/setModal", {
            title: "ระบบไม่พบไฟล์ที่ร้องขอ",
            theme: "warning",
            text: "กรุณาติดต่อเจ้าหน้าที่",
            showCancel: false,
            buttonText: "ตกลง",
          });
        });
    },
    rejectPlan(plan) {
      this.rejectedPlans.push(plan.id);
      this.annexProjects.find(
        (x) => x.plan.plan_master.id === plan.id
      ).is_reject = true;
      for (const x of plan.kpi_masters) {
        if (!x.prefix_flag) this.setKpiField(x.id, 0);
      }
    },
  },
};
</script>

<style scoped></style>
